(() => {
  if (customElements.get('single-product-shop')) return;
  class SingleProductShop extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.form = this.querySelector('form');
      this.variant = this.querySelector('[data-variant]');
      this.quantity = this.querySelector('[name="quantity"]');
      this.buy = this.querySelector('[data-buy]');
      if (!this.form || !this.variant || !this.quantity || !this.buy) return;
      this.subscription = this.buy.textContent.trim() === 'Subscription unavailable';
      this.variant.addEventListener('change', () => this.update(), { signal });
      this.quantity.addEventListener('input', () => this.updateQuantityButtons(), { signal });
      this.querySelectorAll('[data-quantity-change]').forEach(button => {
        button.addEventListener('click', () => {
          if (button.dataset.quantityChange === '1') this.quantity.stepUp();
          else this.quantity.stepDown();
          this.quantity.dispatchEvent(new Event('input', { bubbles: true }));
        }, { signal });
      });
      this.form.addEventListener('submit', event => {
        if (this.buy.disabled || !this.form.reportValidity()) { event.preventDefault(); return; }
        this.buy.disabled = true;
        this.buy.textContent = 'Adding...';
        this.querySelector('[data-status]').textContent = 'Opening your basket...';
        // Native Shopify product form submission owns cart validation and navigation.
      }, { signal });
      window.addEventListener('pageshow', () => this.update(), { signal });
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); }
    update() {
      const option = this.variant.selectedOptions[0];
      if (!option) return;
      this.querySelector('[data-price]').textContent = option.dataset.price;
      const min = Number(option.dataset.min) || 1;
      const step = Number(option.dataset.step) || 1;
      const max = option.dataset.max ? Number(option.dataset.max) : Infinity;
      this.quantity.min = String(min);
      this.quantity.step = String(step);
      if (Number.isFinite(max)) this.quantity.max = String(max);
      else this.quantity.removeAttribute('max');
      const current = Number(this.quantity.value) || min;
      this.quantity.value = String(Math.min(max, min + Math.max(0, Math.floor((current - min) / step)) * step));
      this.buy.disabled = option.dataset.available !== 'true' || this.subscription;
      this.buy.textContent = this.subscription ? 'Subscription unavailable' : this.buy.disabled ? 'Sold out' : this.buy.dataset.label;
      this.querySelector('[data-status]').textContent = '';
      this.updateQuantityButtons();
    }
    updateQuantityButtons() {
      const value = Number(this.quantity.value);
      this.querySelector('[data-quantity-change="-1"]').disabled = value <= Number(this.quantity.min);
      this.querySelector('[data-quantity-change="1"]').disabled = this.quantity.hasAttribute('max') && value >= Number(this.quantity.max);
    }
  }
  customElements.define('single-product-shop', SingleProductShop);
})();
